<mat-drawer-container autosize>
  <mat-drawer #drawer mode="side" class="mat-elevation-z2">
    <div class="col fill">
      <div class="row align-center padding lrg all">
        <mat-icon svgIcon="overtur"></mat-icon>
        @if (isExpanded) {
          <span class="margin left">Restricted Product</span>
        }
      </div>

      <mat-divider></mat-divider>

      <div class="col grow">
        <mat-nav-list>
          @for (link of links; track link.label) {
            <mat-list-item>
              <a class="row align-center" [routerLink]="link.routerLink" [target]="link.target" [href]="link.href">
                <mat-icon>lock</mat-icon>
                @if (isExpanded) {
                  <span class="margin left">{{ link.label }}</span>
                }
              </a>
            </mat-list-item>
          }
        </mat-nav-list>
      </div>

      <div class="upcoming-news margin all">
            <mat-icon class="info-icon">info</mat-icon>
              @if (isExpanded) {
                <div>
                  <div class="upcoming-title">Product News</div>
                  <div class="upcoming-content">
                    Key System Management subscriptions are here.
                    <a
                      href="https://discover-overtur.allegion.com/en/product/overtur-key-system-management.html"
                      class="learn-more"
                      target="_blank"
                      rel="noopener noreferrer"
                      >Learn More</a
                    >
                  </div>
                </div>
              }
          </div>

      <!-- <div class="row">
        <div class="col grow">
          <mat-icon>info</mat-icon>
        </div>
        <div class="col grow">
          <span>Product News</span>
          <span>Key System Management subscriptions are here.
            <a href="https://discover-overtur.allegion.com/en/product/overtur-key-system-management.html"
                class="learn-more"
                target="_blank"
                rel="noopener noreferrer">Learn More</a>
          </span>
        </div>
      </div> -->

      <mat-divider></mat-divider>

      <mat-nav-list>
        @if (isExpanded) {
          <mat-list-item (click)="isExpanded = !isExpanded">
            <div class="row align-center">
              <mat-icon aria-hidden="false" aria-label="Example home icon">west</mat-icon>
              <span class="margin left"> Close </span>
            </div>
          </mat-list-item>
        }

        @if (!isExpanded) {
          <mat-list-item (click)="isExpanded = !isExpanded">
            <div class="row align-center">
              <mat-icon aria-hidden="false" aria-label="Example home icon">east</mat-icon>
            </div>
          </mat-list-item>
        }

        <mat-list-item>
          <a class="row align-center" href="https://auth.allegion.com/samlp/15ifRUv6OVSrkyRQDVOhoisETC5eEOp6?RelayState=https://support.restrictedproduct.allegion.com/" target="_blank" rel="noopener noreferrer" matTooltip="Find how-to articles and troubleshooting help in the Restricted Product Resource Center">
            <mat-icon>local_library</mat-icon>
            @if (isExpanded) {
              <span class="margin left">Resource Center</span>
            }
          </a>
        </mat-list-item>

        <mat-list-item  tourAnchor="support-nav" (click)="toggleSupportModal()">
          <a class="row align-center">
            <mat-icon>help</mat-icon>
            @if (isExpanded) {
              <span class="margin left">Support</span>
            }
          </a>
        </mat-list-item>
        <mat-list-item (click)="toggleUserProfileModal()">
          <div class="row align-center">
            <img class="avatar" id="profile" src="{{ user.profileImage }}" />
            @if (isExpanded) {
              <span class="margin left" id="user-name">{{ user.firstName }} {{ user.lastName }}</span>
            }
          </div>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </mat-drawer>

  <mat-drawer-content>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
